import IntegrationPos from '../../../assets/images/integrations-pos.jpg';
import DiscoverTalent from '../../../assets/images/discover-talent.jpg';
import EnableCreator from '../../../assets/images/enable-creator.jpg';
export const brandData = [
  {
    id: "integration-with-pos",
    laptopTitle: "Integrations With Your POS System",
    mobileTitle: "Integrations With Your POS System",
    para: "Discover if customers, creators, and influencers match your brand with our “Know Your Audience” tool. The Splendid Creator Score effortlessly identifies ideal partners using our advanced filtering and AI-driven algorithm, scoring creators on their selling ability.",
    otherPara:
      "Leverage our technology to farm extensive data insights with millions of data points on social media and sales performance, helping you refine whom you partner with.",
    imageSrc: IntegrationPos
  },
  {
    id: "discover-talent",
    laptopTitle: "Discover Talent That Impacts Your Brand",
    mobileTitle: "Discover Talent That Impacts Your Brand",
    para: "Streamline data synchronization by seamlessly integrating with platforms such as Shopify, WooCommerce, and Salesforce. Our POS integration tool and streamlined creator affiliate network discovery of and product linking for the modern creator. All orders are automatically pushed to your POS, ensuring smooth e-commerce operations.",
    otherPara:
      "",
    imageSrc: DiscoverTalent
  },
  {
    id: "enable-creator",
    laptopTitle: "Enable Creator Commerce & Social Selling",
    mobileTitle: "Enable Creator Commerce & Social Selling",
    para: "Enable creators to access products via the Splendid dashboard, create product collection and marketing (pay-per-click) campaigns for higher engagement, and effortlessly manage PR and gifting strategies, while fostering direct, impactful interactions with creators through our streamlined messaging system.",
    otherPara:
      "",
    liArray : [
        {point: 'Sales Campaigns – enable creators to represent the brand and sell directly.'},
        {point: 'Pay Per Click Campaigns – select creators, share a link, and pay them for every click'},
        {point: 'Sampling Campaigns – create a sampling lookbook, discount products, and invite creators to purchase samples.'},
        {point: 'Gifting Campaigns – create a gifting list, add products, and delight your favorite creators​.'},
    ],
    imageSrc: EnableCreator
  },
];
